import { createFormatter } from 'pejer/src/helpers'
import { defaultTables, defaultUrls } from 'pejer/src/stores/config'
import { Config, ConfigUrls, TableConfig } from 'pejer/src/types/base'

export const userTables = {
  ...defaultTables,
} satisfies TableConfig

const urls = {
  ...defaultUrls,
  bankIntegration: {
    getConsent: {
      path: '/api/bank-integration/consent/{BankIntegrationConsentID}',
      method: 'GET',
      formatter: createFormatter<{
        needsOnboardingInitiation: boolean
        onboardingUrl: string
        renewalRequiredAt: string
        revokedAt: string
        signerName: string
        signingUrl: string
        status:
          | 'Initiated'
          | 'AwaitingOnboarding'
          | 'OnboardingFailed'
          | 'AwaitingSigning'
          | 'AwaitingOnboardingApproval'
          | 'AwaitingConsent'
          | 'Active'
          | 'Revoked'
        userActionRequiredAt: string

        successUrl: string
        failureUrl: string

        userFirstName: string
        userLastName: string
        userEmail: string

        corporateConsents: {
          bic: string
          bankName: string
          redirectUrl: string
          status:
            | 'AUTHORIZATION_UNKNOWN'
            | 'AUTHORIZATION_REQUIRED'
            | 'AUTHORIZATION_COMPLETED'
            | 'AUTHORIZATION_FAILED'
            | 'AUTHORIZATION_REVOKED'
        }[]
        accounts: {
          name: string
          bban: string
          bic: string
          bankName: string
        }[]
      }>(),
    },
    addConsent: {
      path: '/api/bank-integration/consent/{BankIntegrationConsentID}/add',
      method: 'POST',
      formatter: createFormatter<{
        redirectUrl: string
      }>(),
    },
    getBanks: {
      path: '/api/bank-integration/consent/{BankIntegrationConsentID}/banks',
      method: 'GET',
      formatter: createFormatter<
        {
          bic: string
          name: string
          basketSize: number
        }[]
      >(),
    },
    updateConsentStatus: {
      path: '/api/bank-integration/consent/{BankIntegrationConsentID}/status',
      method: 'PATCH',
      // formatter: createFormatter(),
    },
    getBasket: {
      path: '/api/bank-integration/consent/{BankIntegrationConsentID}/baskets/{BankIntegrationBasketID}',
      method: 'GET',
      formatter: createFormatter<{
        data: {
          bankIntegrationConsentID: string
          bankIntegrationBasketID: string
          countryCode: string
          organizationId: string
          description: string | null
          status: 'Created' | 'Pending' | 'Completed' | 'Failed' | 'Cancelled'
          statusUpdatedAt: string | null
          insertTime: string
          bankIntegrationPayments: {
            bankIntegrationPaymentID: string
            bankIntegrationBasketID: string | null
            executionDate: string
            chargeBearer: 'DEBT' | 'CRED' | 'SHAR'
            purpose: {
              code: string | null
              text: string | null
            }
            amount: number
            description: string
            currency: 'NOK' | 'SEK' | 'DKK' | 'EUR' | 'USD' | 'GBP'
            debtorAccountBban: string
            debtorAccountIban: string
            creditorAccountBban: string
            creditorAccountIban: string
            remittance: {
              rawMessage: string | null
              kid: string | null
            }
            statusCode: 'AUTHORIZATION_REQUIRED' | 'AUTHORIZATION_COMPLETED' | 'IN_QUEUE' | null
            statusMessage: string | null
            statusUpdatedAt: string | null
            cancelledAt: string | null
            insertTime: string
          }[]
          redirectUrl: string
          redirectBackUrl: string
        }
      }>(),
    },
    signPayments: {
      path: '/api/bank-integration/consent/{BankIntegrationConsentID}/baskets/{BankIntegrationBasketID}/sign',
      method: 'POST',
      formatter: createFormatter<{
        data: {
          redirectUrl: string
          status: 'AUTHORIZATION_REQUIRED' | 'AUTHORIZATION_COMPLETED' | 'REJECTED'
        }
      }>(),
    },
    updateSignPaymentsStatus: {
      path: '/api/bank-integration/consent/{BankIntegrationConsentID}/baskets/{BankIntegrationBasketID}/sign/status',
      method: 'PATCH',
      // formatter: createFormatter(),
    },
    initiateOnboarding: {
      path: '/api/bank-integration/consent/{BankIntegrationConsentID}/onboard',
      method: 'POST',
      formatter: createFormatter<{
        onboardingUrl: string
        consentStatusCode:
          | 'Initiated'
          | 'AwaitingOnboarding'
          | 'OnboardingFailed'
          | 'AwaitingSigning'
          | 'AwaitingOnboardingApproval'
          | 'AwaitingConsent'
          | 'Active'
          | 'Revoked'
      }>(),
    },
    syncConsentStatus: {
      path: '/api/bank-integration/consent/{BankIntegrationConsentID}/sync',
      method: 'POST',
      formatter: createFormatter<{
        didSync: boolean
      }>(),
    },
  },
} as const satisfies ConfigUrls

export const config = {
  cookieNames: {
    platformToken: 'x-platform-token',
    enviroment: 'x-platform-environment',
  },
  urls,
  schema: {
    tables: userTables,
  },
  columns: {},
} satisfies Config<typeof urls, typeof userTables>
